import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const DivingGearIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "DivingGearIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M15.2656 9.46004C15.0488 9.33911 14.776 9.41834 14.6563 9.63598L12.6894 13.2127C12.5699 13.43 12.6476 13.704 12.8641 13.8247C13.0809 13.9457 13.3537 13.8664 13.4734 13.6488L15.4403 10.0721C15.5598 9.8548 15.482 9.58077 15.2656 9.46004Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.5604 9.46004C17.3435 9.33911 17.0708 9.41834 16.9511 9.63598L14.9841 13.2127C14.8646 13.43 14.9424 13.704 15.1589 13.8247C15.3757 13.9457 15.6485 13.8664 15.7681 13.6488L17.7351 10.0721C17.8546 9.8548 17.7768 9.58077 17.5604 9.46004Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.97841 2.25C5.53427 2.25 5.1753 2.61243 5.1753 3.0582V8.95303C4.54416 9.68847 4.1098 10.6898 4.10986 12C4.10993 13.2589 4.5512 14.1859 5.1753 14.8511V17.0074C5.1753 17.6847 5.39323 18.6831 6.05322 19.5223C6.66752 20.3035 7.64072 20.915 9.0855 21.019C9.12411 21.4287 9.4668 21.75 9.88499 21.75H14.5019C14.946 21.75 15.305 21.3876 15.305 20.9418V18.7958C15.305 18.35 14.946 17.9876 14.5019 17.9876H9.88499C9.50072 17.9876 9.18022 18.2589 9.10078 18.6208C8.7977 18.5543 8.47858 18.4544 8.20355 18.2914C7.9991 18.1702 7.8223 18.0169 7.69625 17.8125C7.57051 17.6086 7.4918 17.3483 7.4918 17.0074V16.1845C8.02066 16.3306 8.49796 16.3849 8.81956 16.3849C9.09198 16.3849 9.52144 16.3449 9.96426 16.2268C10.4 16.1107 10.9025 15.9049 11.2674 15.5374C11.7534 15.048 12.2557 14.9542 12.371 14.9542C12.4864 14.9542 12.9886 15.048 13.4746 15.5374C13.8395 15.9049 14.342 16.1107 14.7777 16.2268C15.2206 16.3449 15.65 16.3849 15.9224 16.3849C16.5217 16.3849 17.6722 16.1958 18.6882 15.5651C19.7287 14.9192 20.6321 13.8019 20.6321 12C20.6322 10.2358 19.8449 9.03417 18.8551 8.28658C17.8843 7.55334 16.7229 7.25741 15.9224 7.25741H8.81956C8.43773 7.25741 7.97541 7.32467 7.4918 7.47345V3.0582C7.4918 2.61243 7.13283 2.25 6.68869 2.25H5.97841ZM6.07123 8.15405V3.15106L6.59587 3.15106V7.84018C6.41835 7.93248 6.24251 8.03685 6.07123 8.15405ZM6.42493 9.00707C7.22994 8.39903 8.19947 8.15847 8.81956 8.15847H15.9224C16.5425 8.15847 17.5121 8.39903 18.3171 9.00707C19.103 9.60072 19.7363 10.5452 19.7362 12C19.7361 13.437 19.0413 14.287 18.2175 14.7984C17.369 15.3252 16.3888 15.4839 15.9224 15.4839C15.7213 15.4839 15.3695 15.4524 15.0073 15.3558C14.638 15.2574 14.3119 15.1055 14.1086 14.9007C13.4581 14.2456 12.7292 14.0532 12.371 14.0532C12.0128 14.0532 11.2839 14.2456 10.6334 14.9007C10.4301 15.1055 10.104 15.2574 9.7347 15.3558C9.37253 15.4524 9.02067 15.4839 8.81956 15.4839C8.35319 15.4839 7.37299 15.3252 6.52446 14.7984C5.70067 14.287 5.00587 13.437 5.0058 12C5.00572 10.5452 5.63898 9.60072 6.42493 9.00707ZM6.07123 17.0074V15.5759C6.24361 15.6819 6.41962 15.7752 6.59587 15.857V17.0074C6.59587 18.0502 7.11681 18.6931 7.74863 19.0677C8.19087 19.3298 8.68607 19.4613 9.08188 19.5364V20.115C7.91717 20.015 7.19861 19.5263 6.75594 18.9634C6.24393 18.3123 6.07123 17.5223 6.07123 17.0074ZM9.97781 20.8489V18.8886H14.409V20.8489H9.97781Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.6532 15.6214C20.9867 15.6214 20.4465 16.1619 20.4465 16.8286C20.4465 17.4953 20.9867 18.0357 21.6532 18.0357C22.3196 18.0357 22.8599 17.4953 22.8599 16.8286C22.8599 16.1619 22.3196 15.6214 21.6532 15.6214ZM21.3747 16.8286C21.3747 16.6747 21.4994 16.55 21.6532 16.55C21.807 16.55 21.9316 16.6747 21.9316 16.8286C21.9316 16.9824 21.807 17.1071 21.6532 17.1071C21.4994 17.1071 21.3747 16.9824 21.3747 16.8286Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3116 17.1071C17.4401 17.1071 16.7336 17.8139 16.7336 18.6857C16.7336 19.5575 17.4401 20.2643 18.3116 20.2643C19.1831 20.2643 19.8896 19.5575 19.8896 18.6857C19.8896 17.8139 19.1831 17.1071 18.3116 17.1071ZM17.6618 18.6857C17.6618 18.3267 17.9527 18.0357 18.3116 18.0357C18.6704 18.0357 18.9613 18.3267 18.9613 18.6857C18.9613 19.0447 18.6704 19.3357 18.3116 19.3357C17.9527 19.3357 17.6618 19.0447 17.6618 18.6857Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default DivingGearIcon;
